import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import {UserManager} from 'oidc-client'
import NKIcon from '@norkart/ikoner'
import { resolve } from '../dependencies'
import Utskiftning from '../utskiftning/utskiftningContainer'


import './forside.css'

export default class Forside extends Component {

    constructor(){       
        super()
        this._forsideErLastet = this._forsideErLastet.bind(this) 
    }

    state = {
        sideErLastet: false,
        kundenavn:''
    }

    componentDidMount(){
        resolve(UserManager).getUser().then(user => {            
            this.setState({
                kundenavn: user.profile.kundenavn
            })
        })       
    }

    _forsideErLastet(){
        this.setState({
            sideErLastet: true
        })     
    }        

    render() {
        return (
            <div className="va-forside">
                <div className="planleggingContainer">
                    <h2 >KOMTEK Vannmålerbytte</h2>                    
                    <p> {this.state.kundenavn}</p>
                </div>

                <div className="planleggingContainer">
                    <div className="va-front-card va-maaler-border">
                        <div className="va-front-card-header va-maaler-background">
                            <Link className="list-group-item-forside minHoyde50 va-maaler-background" to='/planlegging' >
                                <div style={{ float: 'right', overflow: 'hidden' }}>
                                    <NKIcon icon="hoyrepil" color="nk-white" size="1" />
                                </div>
                                <div style={{ float: 'left', overflow: 'hidden' }}>
                                    <strong className='font16 hvitTekst'>Planlegging</strong>
                                </div>
                                <div style={{ float: 'none', clear: 'both' }}></div>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="planleggingContainer">
                    <div className="va-front-card va-maalerplanlagt-border">
                        <div className="va-front-card-header va-planlagt-background">
                            <Link className="list-group-item-forside minHoyde50 va-planlagt-background" to='/utskiftning' >
                                <div style={{ float: 'right', overflow: 'hidden' }}>
                                    <NKIcon icon="hoyrepil" color="nk-white" size="1" />
                                </div>
                                <div style={{ float: 'left', overflow: 'hidden' }}>
                                    <strong className='font16 hvitTekst'>Utskiftning</strong>

                                </div>
                                <div style={{ float: 'none', clear: 'both' }}></div>
                            </Link>
                        </div>
                        <div className="panel-body" >
                             <Utskiftning forside={true} oppdaterForside={this._forsideErLastet} />

                             {!this.state.sideErLastet && <p>Henter data...</p>}
                                
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/forside/forside.jsx